import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const createProductTag = async (
  params: CreateUpdateProductTagBody
): Promise<undefined> => {
  await api.post<unknown>(`/products/product-tags/`, {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [PRODUCT_TAG_QUERY_KEY],
  })
  return
}
